<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <AccordionPrimary :accordion="fields.accordion" label="Accordion" />
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Links</label>
            <v-btn small text color="primary" @click="handleAddLink">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion class="mt-2">
            <v-expansion-panel v-for="(item, index) in fields.links" :key="index">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>{{ item.label || `Item ${index + 1}` }}</span>
                  <v-btn icon @click.stop="handleRemoveLink(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field v-model="item.label" label="Label" hide-details class="mb-3" />
                <v-text-field v-model="item.url" label="URL" hide-details class="mb-3" />
                <v-checkbox v-model="item.openInNewTab" label="Open in new tab" hide-details class="mt-0" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <div class="mb-4">
          <DividerPrimary :divider="fields.divider" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '../common/html/update.js';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import AccordionPrimary from './common/accordion-primary.vue';
import DividerPrimary from './common/divider-primary.vue';

export default {
  name: 'gatorz-support-section-editor',
  components: {
    SectionSettingsContainerFuild,
    AccordionPrimary,
    DividerPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        title: 'Gatorz Support',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        accordion: {
          open: false,
          title: '',
          backgroundColor: '#ffffff',
          color: '#000000',
          icon: {
            type: 'plus-minus',
            position: 'right',
            show: true,
          },
        },
        divider: {
          show: true,
          maxWidth: 9999,
          height: 3,
          backgroundColor: '#C3C3C3',
          align: 'center',
        },
        links: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        accordion: {
          ...this.fields.accordion,
          ...(extract.accordion || {}),
          icon: {
            ...this.fields.accordion.icon,
            ...((extract.accordion || {}).icon || {}),
          },
        },
        divider: { ...this.fields.divider, ...(extract.divider || {}) },
        links: Array.isArray(extract.links) ? extract.links : this.fields.links,
      };
    },
    handleAddLink() {
      this.fields.links.push({
        label: 'New link',
        url: '',
        openInNewTab: false,
      });
    },
    handleRemoveLink(index) {
      this.fields.links.splice(index, 1);
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        links: (this.fields.links || []).map(item => ({
          label: item.label || '',
          url: (item.url || '').trim(),
          openInNewTab: !!item.openInNewTab,
        })),
      };
      const updateHtml = updateHtmlFromData.sectionGatorzSupport(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
</style>
